import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles/index';
import { withRouter } from 'react-router-dom';
import { Table, TableHead, TableRow, TableCell, TableBody, IconButton, Icon, AppBar, Toolbar, Typography, Grid, Select, MenuItem } from '@material-ui/core';
import * as Actions from './../store/actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import BigCalendar from 'react-big-calendar';
import moment from 'moment';

const localizer = BigCalendar.momentLocalizer(moment);

const styles = theme => ({
    select: {
        '&:before': {
            borderColor: "white",
        },
        '&:after': {
            borderColor: "white",
        }
    },
    icon: {
        fill: "white",
    },
});

class Agenda extends Component {
    state = {
        current_date: '',
        start_date: '',
        end_date: '',
        auth_id: 0,
    }

    constructor(props) {
        super(props);

        const auth_id = this.props.auth.user.data.auth_id;
        const current_date = moment(new Date());
        const start_date = current_date.format("YYYY-MM-DD");
        const end_date = current_date.add(1, "M").format("YYYY-MM-DD");

        this.state = {
            ...this.state,
            auth_id,
            current_date,
            start_date,
            end_date
        }
    }

    componentWillMount = () => {
        this.props.getAgendaCourseList(this.state.auth_id);
    }

    handleRowClick = (student_quiz_id) => {
        this.props.history.push(`/quiz/grader/${student_quiz_id}`);
    }

    handleOnSelectChange = (event) => {
        const { start_date, end_date } = this.state;
        const current_course_id = event.target.value;

        this.props.setCurrentCourseID(current_course_id);
        this.props.getAgenda(current_course_id, start_date, end_date);
    }

    render() {
        const { agenda, classes, agenda_course_list, current_course_id } = this.props;

        const agenda_data = agenda_course_list.map((course_info) => (
            <MenuItem value={course_info.company_calendar_course_id} key={course_info.company_calendar_course_id}>{course_info.CourseName}</MenuItem>
        ))

        let agenda_check =
            <BigCalendar
                defaultView='agenda'
                localizer={localizer}
                events={agenda}
                toolbar={false}
            />
        
            if (agenda.length === 0) {
                agenda_check = <Typography className={'text-center p-8'}>No Upcoming Events!</Typography>
            }
        return (
            <div>
                <AppBar position="static">
                    <Toolbar>
                        <Grid container spacing={24}>
                            <Grid item xs={6}>
                                <Typography variant="h6" color="inherit">Agenda</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Select
                                    value={current_course_id}
                                    onChange={this.handleOnSelectChange}
                                    color="inherit"
                                    className={classes.select}
                                    style={{ color: "white" }}
                                    inputProps={{
                                        classes: {
                                            root: classes.border,
                                            icon: classes.icon,
                                        }
                                    }}
                                >
                                    {agenda_data}
                                </Select>
                            </Grid>
                        </Grid>
                    </Toolbar>
                </AppBar>

                {agenda_check}

            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getAgenda: Actions.getAgenda,
        getAgendaCourseList: Actions.getAgendaCourseList,
        setCurrentCourseID: Actions.setCurrentCourseID,
    }, dispatch);
}

function mapStateToProps({ dashboardApp, auth }) {
    return {
        agenda: dashboardApp.widgets.agenda,
        agenda_course_list: dashboardApp.widgets.agenda_course_list,
        current_course_id: dashboardApp.widgets.current_course_id,
        auth: auth,
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(Agenda)));




// WEBPACK FOOTER //
// src/main/content/dashboard/widgets/Agenda.js